import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation exportNcdRiskReadingList(
    $data: emailIdListInput
    $filter: ncdRiskReadingFilterInput
  ) {
    exportNcdRiskReadingList(data: $data, filter: $filter) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const exportNcdRiskReadingListRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data?: TYPES.EmailIdListInput;filter?: TYPES.NcdRiskReadingFilterInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'reading/export_ncd_risk_reading_list',
  async (
  params: {
    data?: TYPES.EmailIdListInput;
    filter?: TYPES.NcdRiskReadingFilterInput;
  },
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.exportNcdRiskReadingList;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const exportNcdRiskReadingListSlice = createSlice({
  name: 'export_ncd_risk_reading_list',
  initialState: initialState,
  reducers: {
    exportNcdRiskReadingListClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(exportNcdRiskReadingListRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      exportNcdRiskReadingListRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      exportNcdRiskReadingListRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { exportNcdRiskReadingListClear } =
exportNcdRiskReadingListSlice.actions;

export const exportNcdRiskReadingList = createSelector(
  (state: RootState) => state.reading.exportNcdRiskReadingList.result,
  (state: RootState) => state.reading.exportNcdRiskReadingList.error,
  (state: RootState) => state.reading.exportNcdRiskReadingList.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default exportNcdRiskReadingListSlice.reducer;